import { render, staticRenderFns } from "./ThreeHeadlines.vue?vue&type=template&id=97d8f4ae&scoped=true&"
import script from "./ThreeHeadlines.vue?vue&type=script&lang=js&"
export * from "./ThreeHeadlines.vue?vue&type=script&lang=js&"
import style0 from "./ThreeHeadlines.vue?vue&type=style&index=0&id=97d8f4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d8f4ae",
  null
  
)

export default component.exports